import { render } from "./FilterClusterGroup.vue?vue&type=template&id=ed384dde"
import script from "./FilterClusterGroup.vue?vue&type=script&lang=js"
export * from "./FilterClusterGroup.vue?vue&type=script&lang=js"
script.render = render

export default script